











import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SnackBar extends Vue {
  @Prop({ required: true }) snackbar: boolean = false;
  @Prop({ required: true }) text!: string;
  @Prop({ required: true }) timeout!: number;
  @Prop({ required: false, default: 'secondary' }) color!: string;

  @Emit('close')
  close() {
    return false;
  }
}
